import SSNWithFlag from 'Components/_NewElements/SSNWithFlag';
import Censorable from 'Components/Censorable';
import SyncAlertIconArea from 'Components/Header/components/SyncAlertIconArea';
import * as React from 'react';
import { useAppSelector as useSelector } from 'Store/index';
import colors from '../../config/theme/colors';
import { styleHeader } from '../../config/theme/componentTheme';

export const NamePlate = (): React.JSX.Element => {
  const headerHeight = parseFloat(styleHeader.height) * 10;
  const [scrollPos, setScrollPos] = React.useState<number>(window.scrollY);
  const [hidden, setHidden] = React.useState<boolean>(false);

  const handleVisibilityClick = () => {
    setHidden(prev => !prev);
  };

  const patientData = useSelector((s: IState) => s.patient.data);

  const lastNames = patientData?.lastNames.toUpperCase() ?? '';
  const firstNames = patientData?.firstNames ?? '';

  window.onscroll = () => {
    setScrollPos(window.scrollY);
  };

  if (scrollPos > headerHeight && patientData) {
    return (
      <div
        style={{
          minWidth: '2.5rem',
          height: '10.5rem',
          backgroundColor: colors.primary,
          position: 'fixed',
          bottom: 30,
          right: 0,
          display: 'flex',
          transform: hidden ? 'translateX(calc(100% - 2.5rem))' : 'translateX(0rem)',
          transformOrigin: 'right',
          transition: 'transform 0.3s ease-out',
          lineHeight: '2rem',
          padding: '0.3rem 0.5rem 0.3rem 0',
        }}
      >
        <>
          <div
            style={{
              width: '2.5rem',
              height: '10.5rem',
              marginRight: '1rem',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={handleVisibilityClick}
          >
            <svg
              width={'100%'}
              height={'100%'}
              viewBox="0 0 16 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                transform: hidden ? 'rotate3d(0, 1, 0, 180deg)' : 'rotate3d(0, 0, 0, 0deg)',
                transition: 'transform 0.5s',
              }}
            >
              <polygon points="3,12 3,37 14,25" fill={colors.appBlue.lightest} />
            </svg>
          </div>
          <div style={{ flex: 8 }}>
            <div
              style={{
                color: colors.white,
                fontWeight: 600,
                textAlign: 'end',
                whiteSpace: 'nowrap',
              }}
            >
              <Censorable>{lastNames}</Censorable>
            </div>
            <div
              style={{
                color: colors.white,
                fontWeight: 600,
                textAlign: 'end',
                whiteSpace: 'nowrap',
              }}
            >
              <Censorable>{firstNames}</Censorable>
            </div>
            <div style={{ color: colors.white, textAlign: 'end' }}>
              <SSNWithFlag patientData={patientData} />
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
              <SyncAlertIconArea iconSize={2} bgColorAlternate tooltipPlacement="top-end" />
            </div>
          </div>
        </>
      </div>
    );
  } else return <></>;
};
